import React from 'react';
// import { setActiveUser, setUserLogoutState } from '../../features/userSlice.js';
// import { useDispatch } from 'react-redux';
// import { auth } from '../../firebase';
// import { DualRing } from 'react-awesome-spinners';
// import { useNavigate } from 'react-router-dom';
import LeftSideAbout from '../../components/LeftSideAbout/LeftSideAbout';
import RightSideAbout from '../../components/RightSideAbout/RightSideAbout';
import ServicesCard from '../../components/ServicesCard/ServicesCard';
import SideOurServices from '../../components/ListOurServices/ListOurServices';
import SliderImage from '../../components/SliderImage/SliderImage';
import TitleServices from '../../components/TitleServices/TitleServices';
import WhyUs from '../../components/WhyUs/WhyUs';
import ContactSection from '../../components/ContactSection/ContactSection';
import FontsDefault from '../../Assistant/DefaultStyle';
import Footer from '../../components/Footer/Footer';
import { motion } from 'framer-motion';

function Home() {
  // const navigate = useNavigate();
  // const dispatch = useDispatch();
  // const [loading, setLoading] = useState(true);

  // useEffect(() => {
  //   const getData = () => {
  //     auth.onAuthStateChanged((authUser) => {
  //       if (authUser) {
  //         setLoading(true);
  //         dispatch(
  //           setActiveUser({
  //             userName: authUser.displayName,
  //             userEmail: authUser.email,
  //           })
  //         );
  //         setLoading(false);
  //       } else {
  //         setLoading(true);
  //         dispatch(setUserLogoutState());
  //         navigate('/login');
  //         setLoading(false);
  //       }
  //     });
  //   };
  //   getData();
  // }, [dispatch, loading, navigate]);

  // <div className='flex justify-center items-center h-screen w-full z-50'>
  //         <DualRing size={100} color='#22c55e' />
  //       </div>


  return (
    <motion.div
      initial={{ width: 0, opacity: 0 }}
      animate={{ width: '100vw', opacity: 1 }}
      exit={{
        width: window.innerWidth,
        opacity: 0,
        transition: { duration: 0.1 },
      }}
    >
      <SliderImage />
      <div className={`md:py-24 py-20 lg:w-9/12 w-11/12 md:flex justify-between lg:flex-row flex md:flex-col flex-col mx-auto text-textColor items-center `}>
        <SideOurServices />
      </div>

      <div
        className={`${FontsDefault.defaultContainer} md:flex-row items-center `}
      >
        <RightSideAbout />
        <div
          className={`grid lg:grid-rows gap-8 md:grid-cols-2 grid-flow-col-1 md:w-9/12 lg:w-6/12 w-full md:py-8 py-10 `}
        >
          <LeftSideAbout />
        </div>
      </div>

      <div className={`${FontsDefault.defaultContainerWidth}`} >
        <TitleServices
          showBtn={true}
          title='خدماتنا'
          description='ما هي الحلول التي نقدمها لعملائنا الكرام'
        />
        <div
          className={`${FontsDefault.defaultGridContainer} md:grid-cols-3 grid-cols-1 w-full`}
        >
          <ServicesCard />
        </div>
      </div>

      <div className={FontsDefault.defaultContainer}>
        <WhyUs />
      </div>

      <div className={FontsDefault.defaultContainer}>
        <ContactSection />
      </div>

      <Footer />
    </motion.div>
  );
}

export default Home;
